import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";
export const HEADING2 = "HEADING2";
export const CLASSIFICATION_OF_LUGGAGE = "CLASSIFICATION_OF_LUGGAGE";

export const LL_HEADING = "LL_HEADING";
export const LL_P1 = "LL_P1";
export const LL_LI1 = "LL_LI1";
export const LL_LI2 = "LL_LI2";
export const LL_LI3 = "LL_LI3";
export const LL_LI4 = "LL_LI4";

export const HL_HEADING = "HL_HEADING";
export const HL_P1 = "HL_P1";
export const HL_LI1 = "HL_LI1";
export const HL_LI2 = "HL_LI2";
export const HL_LI3 = "HL_LI3";
export const HL_LI4 = "HL_LI4";
export const HL_LI5 = "HL_LI5";

export const PA_HEADING = "PA_HEADING";
export const PA_LINE1 = "PA_LINE1";
export const PA_LINE2 = "PA_LINE2";
export const PA_LINE3 = "PA_LINE3";

export const PETA_HEADING = "PETA_HEADING";

export const PETA_LI1 = "PETA_LI1";
export const PETA_LI2 = "PETA_LI2";
export const PETA_LI3 = "PETA_LI3";
export const PETA_LI4 = "PETA_LI4";
export const PETA_NOTE = "PETA_NOTE";
export const PETA_NOTE_TXT = "PETA_NOTE_TXT";

export const COCOON_HEADING = "COCOON_HEADING";
export const COCOON_P1 = "COCOON_P1";

export const FA_HEADING = "FA_HEADING";
export const FA_LI1 = "FA_LI1";
export const FA_LI2 = "FA_LI2";
export const FA_LI3 = "FA_LI3";
export const FA_LI4 = "FA_LI4";
export const FA_LI5 = "FA_LI5";
export const FA_LI6 = "FA_LI6";

export const LUGGAGE_RATES = "LUGGAGE_RATES";
export const LR_P1 = "LR_P1";
export const LR_P2 = "LR_P2";
export const LR_P3 = "LR_P3";

export const LR_P4 = "LR_P4";
export const LR_RS = "LR_RS";

export const LR_P5 = "LR_P5";

export const PROHIBITED_LUGGAGES = "PROHIBITED_LUGGAGES";

export const PL_PETROL_GAS_KEROSENE = "PL_PETROL_GAS_KEROSENE";
export const PL_ALCOHOL = "PL_ALCOHOL";
export const PL_GASOLINE = "PL_GASOLINE";
export const PL_SPIRIT_TURPENTINE = "PL_SPIRIT_TURPENTINE";
export const PL_ACID = "PL_ACID";
export const PL_SULPHER = "PL_SULPHER";
export const PL_COOL_TAR = "PL_COOL_TAR";

export const IMP_TNC = "IMP_TNC";

export const IMP_LI1 = "IMP_LI1";
export const IMP_LI2 = "IMP_LI2";
export const IMP_LI3 = "IMP_LI3";
export const IMP_LI4 = "IMP_LI4";
export const IMP_LI5 = "IMP_LI5";
export const IMP_LI6 = "IMP_LI6";
export const IMP_LI7 = "IMP_LI7";

export const translations = {
  en: {
    [HEADING1]: "Luggage Transportation and Charges",
    [HEADING2]:
      "The KSRTC allows transportation of luggage by passengers, important guidelines related to luggage transportation are as below:",
    [CLASSIFICATION_OF_LUGGAGE]: "I. Classification of Luggage :",
    [LL_HEADING]: "1. Light luggage:",
    [LL_P1]:
      "Luggage occupying more space and low weighing are charged at 10 kgs per unit.",
    [LL_LI1]: "Cotton bales non pressed",
    [LL_LI2]: "Aluminium utensils/pipes,",
    [LL_LI3]: "Plastic utensils / pipes,decorative items etc",
    [LL_LI4]: "Flowers,Leaves,Decorative grass etc",

    [HL_HEADING]: "2. Heavy luggage:",
    [HL_P1]: "Heavy luggage are toe charged at  b20 kgs / unit.",
    [HL_LI1]: "Agricultural products / vegetables/ fruits",
    [HL_LI2]: "Manure",
    [HL_LI3]: "Pulses / Seeds",
    [HL_LI4]: "Motors /pumps / Iron pipes",
    [HL_LI5]: "Suitcase / Bed- roll and any other luggage",

    [PA_HEADING]: "3. Portable Articles :",
    [PA_LINE1]: "Truck Tyre",
    [PA_LINE2]: "Refrigerator / Bicycle / Veena / Washing Machine / Car tyre",
    [PA_LINE3]:
      "TV / Computer monitor / Empty container upto 25 litres Capacity / CPU / Battery / Table Fan",
    [PETA_HEADING]: "4. Pet Animals :",
    [PETA_LI1]:
      "Pet animals/ birds are allowed in City, Suburban, Ordinary and Mofussil services only. Pet animals/ birds are not allowed in premium services like Karnataka Vaibhava, Rajahamsa, Non AC sleeper and all Air -conditioned services.",
    [PETA_LI2]:
      "Rabbit, pup, cat, bird, birds in cage etc. are charged at the child fare prescribed.",
    [PETA_LI3]:
      "Pet animals are allowed at the risk of accompanying passengers. Pets shall be carried in baskets, tied with chains and facemasks.",
    [PETA_LI4]:
      "Passengers should ensure safe keep of pets and not to cause disturbance to other passengers / bus crew / KSRTC property.",
    [PETA_NOTE]: "Note-",
    [PETA_NOTE_TXT]:
      "Pet animals shall be charged as indicated above and shall under no circumstances be treated as part of free allowance.",

    [COCOON_HEADING]: "5. Cocoon:",
    [COCOON_P1]: "Cocoon will be charged at 15 kgs / unit.",
    [FA_HEADING]: "6. Free allowance:",

    [FA_LI1]:
      "Every passenger is allowed to carry luggage (all inclusive) free of cost to an extent of 30 kgs in case of adult and 15 kgs in case of chargeable child.",
    [FA_LI2]:
      "If the luggage carried by the passenger is more than the permissible free allowance then the luggage is to be charged after allowing free allowance applicable to the passenger concerned.",
    [FA_LI3]:
      "In case adult passenger carried more than 30 kgs, then above the 30 kgs luggage is to be charged.",
    [FA_LI4]:
      "Passengers traveling in a group of 4 or 5 persons carrying the luggage articles in a single bag or bundle are allowed free allowance for one person (30 kgs) only.",
    [FA_LI5]:
      "Free luggage allowance is allowed for personal baggage only. Other luggage like portable articles and / or commercial goods will be charged as per rules.",
    [FA_LI6]:
      "An Adult passenger intends to carry bed-roll of 5 kgs and is accompanied by a dog. The bed roll to be allowed free. However, the Dog is to be charged.",

    [LUGGAGE_RATES]: "II. Luggage Rates:",
    [LR_P1]: "Luggage rates beyond free luggage allowance is as below:",
    [LR_P2]: "Service Type",
    [LR_P3]: "Rate per unit per chargeable stage",
    [LR_P4]: "Minimum Fare",
    [LR_RS]: "Rs",
    [LR_P5]:
      "All Non-AC services (City, Suburban, Ordinary,Karnataka Sarige, Rajahamsa, Karnataka Vaibhav, Non-AC Sleeper services etc.) and All Air-conditioned services (Airavat, AC Sleeper, Airavat Club Class, Flybus, Corona etc.)",

    [PROHIBITED_LUGGAGES]: "III. Prohibited Luggages:",

    [PL_PETROL_GAS_KEROSENE]: "Petrol, Gas, Kerosene",
    [PL_ALCOHOL]: "Alcohol",
    [PL_GASOLINE]: "Gasoline",
    [PL_SPIRIT_TURPENTINE]: "Spirit,turpentine",
    [PL_ACID]: "Acid",
    [PL_SULPHER]: "Sulpher",
    [PL_COOL_TAR]: "Cool Tar",
    [IMP_TNC]: "IV. Important terms and conditions:",

    [IMP_LI1]:
      "The corporation reserves the right to accept / reject any luggage.",
    [IMP_LI2]:
      "Luggage in packed conditions will be allowed subject to availability of the space.",
    [IMP_LI3]:
      "Articles which are offensive, contraband, explosive or otherwise dangerous to the safety of passengers shall not be accepted for carriage.",
    [IMP_LI4]:
      "Corporation will not be responsible for any loss or damage caused to the luggage due to unforeseen circumstances or due to accident to the vehicle carrying the luggage or improper packing.",
    [IMP_LI5]:
      "In case of any doubt regarding the contents of the luggage, the same will be liable for inspection by the KSRTC staff.",
    [IMP_LI6]:
      "Under no circumstances, bulk luggage will be carried inside the bus, affecting the movement of passengers or staff, or in the driver’s cabin.",
    [IMP_LI7]:
      "If the luggage carried in the bus is not charged at the boarding point, a penalty equivalent to two times the luggage fare be imposed on the person who carries luggage.",
  },
  kn: {
    [HEADING1]: "ಲಗೇಜ್ ಸಾರಿಗೆ ಮತ್ತು ಶುಲ್ಕಗಳು",
    [HEADING2]:
      "KSRTC ಪ್ರಯಾಣಿಕರಿಂದ ಸಾಮಾನು ಸಾಗಣೆಯನ್ನು ಅನುಮತಿಸುತ್ತದೆ, ಲಗೇಜ್ ಸಾಗಣೆಗೆ ಸಂಬಂಧಿಸಿದ ಪ್ರಮುಖ ಮಾರ್ಗಸೂಚಿಗಳು ಕೆಳಕಂಡಂತಿವೆ:",
    [CLASSIFICATION_OF_LUGGAGE]: "I. ಸಾಮಾನುಗಳ ವರ್ಗೀಕರಣ:",
    [LL_HEADING]: "1. ಲೈಟ್ ಲಗೇಜ್:",
    [LL_P1]:
      "Luggage occupying more space and low weighing are charged at 10 kgs per unit.",
    [LL_LI1]: "ಕಾಟನ್ ಬೇಲ್ಸ್ ನಾನ್ ಪ್ರೆಸ್ಡ್",
    [LL_LI2]: "ಅಲ್ಯೂಮಿನಿಯಂ ಪಾತ್ರೆಗಳು/ಕೊಳವೆಗಳು,",
    [LL_LI3]: "ಪ್ಲಾಸ್ಟಿಕ್ ಪಾತ್ರೆಗಳು / ಪೈಪ್‌ಗಳು, ಅಲಂಕಾರಿಕ ವಸ್ತುಗಳು ಇತ್ಯಾದಿ",
    [LL_LI4]: "ಹೂವುಗಳು, ಎಲೆಗಳು, ಅಲಂಕಾರಿಕ ಹುಲ್ಲು ಇತ್ಯಾದಿ",
    [HL_HEADING]: "2. ಭಾರವಾದ ಲಗೇಜ್:",
    [HL_P1]: "ಭಾರವಾದ ಲಗೇಜ್ಗಳನ್ನು 20 ಕೆಜಿ / ಯೂನಿಟ್‌ನಲ್ಲಿ ವಿಧಿಸಲಾಗುತ್ತದೆ.",
    [HL_LI1]: "ಕೃಷಿ ಉತ್ಪನ್ನಗಳು / ತರಕಾರಿಗಳು / ಹಣ್ಣುಗಳು",
    [HL_LI2]: "ಗೊಬ್ಬರ",
    [HL_LI3]: "ದ್ವಿದಳ ಧಾನ್ಯಗಳು / ಬೀಜಗಳು",
    [HL_LI4]: "ಮೋಟಾರ್ಗಳು / ಪಂಪ್ಗಳು / ಕಬ್ಬಿಣದ ಪೈಪ್ಗಳು",
    [HL_LI5]: "ಸೂಟ್ಕೇಸ್ / ಬೆಡ್ ರೋಲ್ ಮತ್ತು ಯಾವುದೇ ಇತರ ಲಗೇಜ್",

    [PA_HEADING]: "3. ಪೋರ್ಟಬಲ್ ಲೇಖನಗಳು:",
    [PA_LINE1]: "ಟ್ರಕ್ ಟೈರ್",
    [PA_LINE2]: "ರೆಫ್ರಿಜರೇಟರ್ / ಬೈಸಿಕಲ್ / ವೀಣೆ / ವಾಷಿಂಗ್ ಮೆಷಿನ್ / ಕಾರ್ ಟೈರ್",
    [PA_LINE3]:
      "ಟಿವಿ / ಕಂಪ್ಯೂಟರ್ ಮಾನಿಟರ್ / 25 ಲೀಟರ್ ಸಾಮರ್ಥ್ಯದವರೆಗೆ ಖಾಲಿ ಕಂಟೇನರ್ / ಸಿಪಿಯು / ಬ್ಯಾಟರಿ / ಟೇಬಲ್ ಫ್ಯಾನ್",
    [PETA_HEADING]: "4. ಸಾಕು ಪ್ರಾಣಿಗಳು:",
    [PETA_LI1]:
      "ನಗರ, ಉಪನಗರ, ಸಾಮಾನ್ಯ ಮತ್ತು ಮೊಫುಸಿಲ್ ಸೇವೆಗಳಲ್ಲಿ ಮಾತ್ರ ಸಾಕುಪ್ರಾಣಿಗಳು/ಪಕ್ಷಿಗಳನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ. ಕರ್ನಾಟಕ ವೈಭವ, ರಾಜಹಂಸ, ನಾನ್ ಎಸಿ ಸ್ಲೀಪರ್ ಮತ್ತು ಎಲ್ಲಾ ಹವಾನಿಯಂತ್ರಿತ ಸೇವೆಗಳಂತಹ ಪ್ರೀಮಿಯಂ ಸೇವೆಗಳಲ್ಲಿ ಸಾಕು ಪ್ರಾಣಿಗಳು/ಪಕ್ಷಿಗಳನ್ನು ಅನುಮತಿಸಲಾಗುವುದಿಲ್ಲ.",
    [PETA_LI2]:
      "ಮೊಲ, ನಾಯಿಮರಿ, ಬೆಕ್ಕು, ಪಕ್ಷಿ, ಪಂಜರದಲ್ಲಿರುವ ಪಕ್ಷಿಗಳು ಇತ್ಯಾದಿಗಳಿಗೆ ನಿಗದಿತ ಮಕ್ಕಳ ಶುಲ್ಕವನ್ನು ವಿಧಿಸಲಾಗುತ್ತದೆ.",
    [PETA_LI3]:
      "ಸಾಕುಪ್ರಾಣಿಗಳನ್ನು ಪ್ರಯಾಣಿಕರೊಂದಿಗೆ ಅಪಾಯದಲ್ಲಿ ಅನುಮತಿಸಲಾಗಿದೆ. ಸಾಕುಪ್ರಾಣಿಗಳನ್ನು ಬುಟ್ಟಿಗಳಲ್ಲಿ ಕೊಂಡೊಯ್ಯಬೇಕು, ಸರಪಳಿಗಳು ಮತ್ತು ಮುಖವಾಡಗಳಿಂದ ಕಟ್ಟಲಾಗುತ್ತದೆ.",
    [PETA_LI4]:
      "ಪ್ರಯಾಣಿಕರು ಸಾಕುಪ್ರಾಣಿಗಳನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಇಟ್ಟುಕೊಳ್ಳುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಬೇಕು ಮತ್ತು ಇತರ ಪ್ರಯಾಣಿಕರಿಗೆ / ಬಸ್ ಸಿಬ್ಬಂದಿಗೆ / KSRTC ಆಸ್ತಿಗೆ ತೊಂದರೆಯಾಗದಂತೆ ನೋಡಿಕೊಳ್ಳಬೇಕು.",
    [PETA_NOTE]: "ಗಮನಿಸಿ-",
    [PETA_NOTE_TXT]:
      "ಸಾಕು ಪ್ರಾಣಿಗಳಿಗೆ ಮೇಲೆ ಸೂಚಿಸಿದಂತೆ ಶುಲ್ಕ ವಿಧಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಯಾವುದೇ ಸಂದರ್ಭದಲ್ಲಿ ಉಚಿತ ಭತ್ಯೆಯ ಭಾಗವಾಗಿ ಪರಿಗಣಿಸಲಾಗುವುದಿಲ್ಲ.",

    [COCOON_HEADING]: "5. ಕೋಕೂನ್:",
    [COCOON_P1]: "ಕೋಕೂನ್‌ಗೆ 15 ಕೆಜಿ / ಯೂನಿಟ್ ದರ ವಿಧಿಸಲಾಗುತ್ತದೆ.",
    [FA_HEADING]: "6. ಉಚಿತ ಭತ್ಯೆ:",

    [FA_LI1]:
      "ಪ್ರತಿಯೊಬ್ಬ ಪ್ರಯಾಣಿಕರು ವಯಸ್ಕರ ಸಂದರ್ಭದಲ್ಲಿ 30 ಕೆಜಿ ಮತ್ತು ಶುಲ್ಕ ವಿಧಿಸಬಹುದಾದ ಮಗುವಿನ ಸಂದರ್ಭದಲ್ಲಿ 15 ಕೆಜಿಗಳವರೆಗೆ ಲಗೇಜ್ ಳನ್ನು (ಎಲ್ಲವನ್ನೂ ಒಳಗೊಂಡಂತೆ) ಉಚಿತವಾಗಿ ಸಾಗಿಸಲು ಅನುಮತಿಸಲಾಗಿದೆ.",
    [FA_LI2]:
      "ಪ್ರಯಾಣಿಕರು ಸಾಗಿಸುವ ಲಗೇಜ್ ಅನುಮತಿಸುವ ಉಚಿತ ಭತ್ಯೆಗಿಂತ ಹೆಚ್ಚಿದ್ದರೆ, ಸಂಬಂಧಪಟ್ಟ ಪ್ರಯಾಣಿಕರಿಗೆ ಅನ್ವಯವಾಗುವ ಉಚಿತ ಭತ್ಯೆಯನ್ನು ಅನುಮತಿಸಿದ ನಂತರ ಲಗೇಜ್ ಅನ್ನು ವಿಧಿಸಬೇಕು.",
    [FA_LI3]:
      "ವಯಸ್ಕ ಪ್ರಯಾಣಿಕರು 30 ಕೆಜಿಗಿಂತ ಹೆಚ್ಚು ಸಾಗಿಸಿದರೆ, ನಂತರ 30 ಕೆಜಿಗಿಂತ ಹೆಚ್ಚಿನ ಲಗೇಜ್ ಅನ್ನು ವಿಧಿಸಬೇಕು.",
    [FA_LI4]:
      "4 ಅಥವಾ 5 ಜನರ ಗುಂಪಿನಲ್ಲಿ ಪ್ರಯಾಣಿಸುವ ಪ್ರಯಾಣಿಕರು ಒಂದೇ ಚೀಲ ಅಥವಾ ಬಂಡಲ್‌ನಲ್ಲಿ ಲಗೇಜ್ ಸಾಮಗ್ರಿಗಳನ್ನು ಸಾಗಿಸುವವರಿಗೆ ಒಬ್ಬ ವ್ಯಕ್ತಿಗೆ (30 ಕೆಜಿ) ಮಾತ್ರ ಉಚಿತ ಭತ್ಯೆಯನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ.",
    [FA_LI5]:
      "ವೈಯಕ್ತಿಕ ಲಗೇಜ್ ಸರಂಜಾಮುಗಳಿಗೆ ಮಾತ್ರ ಉಚಿತ ಲಗೇಜ್ ಭತ್ಯೆಯನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ. ಪೋರ್ಟಬಲ್ ಲೇಖನಗಳು ಮತ್ತು / ಅಥವಾ ವಾಣಿಜ್ಯ ಸರಕುಗಳಂತಹ ಇತರ ಲಗೇಜ್‌ಗಳಿಗೆ ನಿಯಮಗಳ ಪ್ರಕಾರ ಶುಲ್ಕ ವಿಧಿಸಲಾಗುತ್ತದೆ.",
    [FA_LI6]:
      "ವಯಸ್ಕ ಪ್ರಯಾಣಿಕನು 5 ಕೆಜಿಯ ಬೆಡ್-ರೋಲ್ ಅನ್ನು ಸಾಗಿಸಲು ಉದ್ದೇಶಿಸಿದ್ದಾನೆ ಮತ್ತು ನಾಯಿಯೊಂದಿಗೆ ಇರುತ್ತದೆ. ಬೆಡ್ ರೋಲ್ ಅನ್ನು ಉಚಿತವಾಗಿ ಅನುಮತಿಸಬೇಕು. ಆದಾಗ್ಯೂ, ನಾಯಿಯನ್ನು ಚಾರ್ಜ್ ಮಾಡಬೇಕು.",

    [LUGGAGE_RATES]: "II. ಲಗೇಜ್ ದರಗಳು:",
    [LR_P1]: "ಉಚಿತ ಲಗೇಜ್ ಭತ್ಯೆ ಮೀರಿದ ಲಗೇಜ್ ದರಗಳು ಕೆಳಕಂಡಂತಿವೆ:",
    [LR_P2]: "ಸೇವೆಯ ಪ್ರಕಾರ",
    [LR_P3]: "ಪ್ರತಿ ಚಾರ್ಜ್ ಮಾಡಬಹುದಾದ ಹಂತಕ್ಕೆ ಪ್ರತಿ ",
    [LR_P4]: "ಕನಿಷ್ಠ ದರ",
    [LR_RS]: "ರೂ",
    [LR_P5]:
      "ಎಲ್ಲಾ ನಾನ್-ಎಸಿ ಸೇವೆಗಳು (ನಗರ, ಉಪನಗರ, ಸಾಮಾನ್ಯ, ಕರ್ನಾಟಕ ಸರಿಗೆ, ರಾಜಹಂಸ, ಕರ್ನಾಟಕ ವೈಭವ, ನಾನ್-ಎಸಿ ಸ್ಲೀಪರ್ ಸೇವೆಗಳು ಇತ್ಯಾದಿ) ಮತ್ತು ಎಲ್ಲಾ ಹವಾನಿಯಂತ್ರಿತ ಸೇವೆಗಳು (ಐರಾವತ್, ಎಸಿ ಸ್ಲೀಪರ್, ಐರಾವತ್ ಕ್ಲಬ್ ಕ್ಲಾಸ್, ಫ್ಲೈಬಸ್, ಕರೋನಾ ಇತ್ಯಾದಿ)",
    [PROHIBITED_LUGGAGES]: "III. ನಿಷೇಧಿತ ಲಗೇಜ್:",

    [PL_PETROL_GAS_KEROSENE]: "ಪೆಟ್ರೋಲ್, ಗ್ಯಾಸ್, ಸೀಮೆಎಣ್ಣೆ",
    [PL_ALCOHOL]: "ಮದ್ಯ",
    [PL_GASOLINE]: "ಗ್ಯಾಸೋಲಿನ್",
    [PL_SPIRIT_TURPENTINE]: "ಸ್ಪಿರಿಟ್, ಟರ್ಪಂಟೈನ್",
    [PL_ACID]: "ಆಮ್ಲ",
    [PL_SULPHER]: "ಸಲ್ಫರ್",
    [PL_COOL_TAR]: "ಕೂಲ್ ಟಾರ್",
    [IMP_TNC]: "IV. ಪ್ರಮುಖ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು:",

    [IMP_LI1]:
      "ಯಾವುದೇ ಲಗೇಜ್ ಸರಂಜಾಮುಗಳನ್ನು ಸ್ವೀಕರಿಸುವ / ತಿರಸ್ಕರಿಸುವ ಹಕ್ಕನ್ನು ನಿಗಮವು ಕಾಯ್ದಿರಿಸಿಕೊಂಡಿದೆ.",
    [IMP_LI2]:
      "ಸ್ಥಳಾವಕಾಶದ ಲಭ್ಯತೆಗೆ ಒಳಪಟ್ಟು ಪ್ಯಾಕ್ ಮಾಡಲಾದ ಪರಿಸ್ಥಿತಿಗಳಲ್ಲಿ ಲಗೇಜ್ ಅನ್ನು ಅನುಮತಿಸಲಾಗುತ್ತದೆ.",
    [IMP_LI3]:
      "ಆಕ್ಷೇಪಾರ್ಹ, ನಿಷಿದ್ಧ, ಸ್ಫೋಟಕ ಅಥವಾ ಪ್ರಯಾಣಿಕರ ಸುರಕ್ಷತೆಗೆ ಅಪಾಯಕಾರಿಯಾದ ಲೇಖನಗಳನ್ನು ಸಾಗಣೆಗೆ ಸ್ವೀಕರಿಸಲಾಗುವುದಿಲ್ಲ.",
    [IMP_LI4]:
      "ಅನಿರೀಕ್ಷಿತ ಸಂದರ್ಭಗಳಿಂದ ಅಥವಾ ಲಗೇಜ್ ಸಾಗಿಸುವ ವಾಹನಕ್ಕೆ ಅಪಘಾತ ಅಥವಾ ಅಸಮರ್ಪಕ ಪ್ಯಾಕಿಂಗ್‌ನಿಂದಾಗಿ ಲಗೇಜ್‌ಗೆ ಉಂಟಾಗುವ ಯಾವುದೇ ನಷ್ಟ ಅಥವಾ ಹಾನಿಗೆ ನಿಗಮವು ಜವಾಬ್ದಾರನಾಗಿರುವುದಿಲ್ಲ.",
    [IMP_LI5]:
      "ಲಗೇಜ್ ಸರಂಜಾಮುಗಳ ವಿಷಯಗಳ ಬಗ್ಗೆ ಯಾವುದೇ ಅನುಮಾನವಿದ್ದಲ್ಲಿ, KSRTC ಸಿಬ್ಬಂದಿಯ ತಪಾಸಣೆಗೆ ಹೊಣೆಗಾರರಾಗಿರುತ್ತಾರೆ.",
    [IMP_LI6]:
      "ಯಾವುದೇ ಸಂದರ್ಭಗಳಲ್ಲಿ, ಬೃಹತ್ ಲಗೇಜ್ ಗಳನ್ನು ಬಸ್‌ನೊಳಗೆ ಸಾಗಿಸಲಾಗುವುದಿಲ್ಲ, ಇದು ಪ್ರಯಾಣಿಕರು ಅಥವಾ ಸಿಬ್ಬಂದಿಯ ಚಲನೆಯ ಮೇಲೆ ಅಥವಾ ಚಾಲಕನ ಕ್ಯಾಬಿನ್‌ನಲ್ಲಿ ಪರಿಣಾಮ ಬೀರುತ್ತದೆ.",
    [IMP_LI7]:
      "ಬಸ್‌ನಲ್ಲಿ ಸಾಗಿಸುವ ಲಗೇಜ್‌ಗೆ ಬೋರ್ಡಿಂಗ್ ಪಾಯಿಂಟ್‌ನಲ್ಲಿ ಶುಲ್ಕ ವಿಧಿಸದಿದ್ದರೆ, ಲಗೇಜ್ ಸಾಗಿಸುವ ವ್ಯಕ್ತಿಗೆ ಲಗೇಜ್ ಶುಲ್ಕದ ಎರಡು ಪಟ್ಟು ದಂಡವನ್ನು ವಿಧಿಸಲಾಗುತ್ತದೆ.",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
